export const MAX_VALUES_NUMBER = 1.7976931348623157e+308;
export const MIN_VALUES_NUMBER = -1.7976931348623157e+308;
export const INFINITY = Infinity; // 无限

/**
 * @description 空值(undefined, null, NaN)
 */
export const EMPTY = [ undefined, null, NaN ]